const key = 'soulthread.pending-sign-outs';
let flushing = false;
function pending(): string[] {
  try {
    const value: unknown = JSON.parse(localStorage.getItem(key) || '[]');
    return Array.isArray(value)
      ? value.filter((item): item is string => typeof item === 'string')
      : [];
  } catch {
    return [];
  }
}
export async function flushSignOuts() {
  if (flushing) return;
  flushing = true;
  try {
    for (const token of pending()) {
      const response = await fetch('/api/auth/logout', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        signal: AbortSignal.timeout(10000),
      }).catch(() => null);
      if (response?.ok)
        localStorage.setItem(key, JSON.stringify(pending().filter((value) => value !== token)));
    }
  } finally {
    flushing = false;
  }
}
export function rememberSignOut(token: string) {
  localStorage.setItem(key, JSON.stringify([...new Set([...pending(), token])]));
  void flushSignOuts();
}
